export default __webpack_public_path__ + "static/media/testimonial-avatar-2.b743d327.jpg";